import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
Vue.use(Vuex);
const state = {
    assemblyData:{
        name: '', //试卷名称
        department: '',//学部
        grade_id: '', //年级
        subject_ids: [], //学科ID列表，多个逗号隔开
        paper_type: 1, //试卷类型：1 考试卷, 2 测试卷
        test_type: '', //试题类型：1 客观题 2 主观题 3 主客混合 4 语音测评
        paper_time: '', //试卷考试时间分钟数
        id: 0, //试卷ID，没有则为0
        sub_title: '', //试卷副标题
        notice: '请填写注意事项', //试卷注意事项
        segment_list: [], //本地记录的试卷组列表
        options: { //试卷样式控制相关参数
            struct_title: 1, //显示主标题：1 显示  0 不显示
            struct_subtitle: 0, //显示副标题： 1 显示  0 不显示
            struct_student: 0, //显示考生信息: 1 显示  0 不显示
            struct_notice: 0, //显示注意事项: 1 显示  0 不显示
            struct_segment: 1, //显示分大题: 1 显示  0 不显示
            struct_segmentmemo: 1 //显示大题注释: 1 显示  0 不显示
        }
    },
    segment_list:[],//后台返回的组卷试题列表详情
    departmentList:[],//学部列表
    currentNode:[],//当前选中节点
    setScoreShow:false,//设置分数窗口
    questionTransferOutShow:false,//设置转出窗口
    questionTransferEnterShow:false,//试题转入题组窗口
    assembleTestDetailsShow:false,//试卷详情窗口
    collectViewShow:false,//收藏窗口
    spacingViewShow:false,//设置分数窗口
    boxDragEnter:false,//小题接收容器是否显示
    scrollTimer:'',//滚动动画定时器
    local_name:''
};

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
});


// WEBPACK FOOTER //
// ./packages/question-assembly/store/index.js